var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardHeader"},[_c('div',{staticClass:"drawer_header"},[_c('div',{staticClass:"header_title"},[_vm._v(" "+_vm._s(_vm.name)+" "),_c('div',{staticClass:"bgIMg"})]),(!_vm.noclose)?_c('i',{staticClass:"el-icon-close close",on:{"click":_vm.closeDrawer}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }